import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { LinearCalMethodViewModel, CalculationMethodType } from '../../model/measurement-points.model';

@Component({
  selector: 'linear-cal-method',
  templateUrl: './linear-cal-method.component.html',
  styleUrls: ['./linear-cal-method.component.scss']
})
export class LinearCalMethodComponent implements AfterViewInit, OnInit{
  
  @Input() linearCalModel: LinearCalMethodViewModel;








  constructor() { }


  ngOnInit(): void {
    if(this.linearCalModel==undefined){
      this.linearCalModel = new LinearCalMethodViewModel();
   
    }
      
  }


  ngAfterViewInit() {
   
  }

  saveChanges() {  

  
  }


  setViewModel(LinearCalMethodViewModel :LinearCalMethodViewModel){
      this.linearCalModel = LinearCalMethodViewModel;     
      console.log(this.linearCalModel)
  }

}
